import { render, staticRenderFns } from "./SetImageSlot.vue?vue&type=template&id=df0d6c56"
import script from "./SetImageSlot.vue?vue&type=script&lang=js"
export * from "./SetImageSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports